import _ from "lodash";
import store from "services/redux/store";
import { setBookingsPast } from "services/redux/data/actions";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchMyBooking from "utils/fetch/FetchMyBooking";

export default class FetchCachedMyPastBooking
{
	static logName = 'FetchCachedMyPastBooking';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'my_past_bookings',
				tables: [ 'my_past_bookings' ],
				//tables: [],
				onExpire: this.reload,
				updated_at_max_age: ( 2 * 60 ) // updated_at needs to be refresh at most each 2 minutes for this table
			}, this.process )
		);
	};
	
	static fetchAll = ( {callbackSuccess = null, callbackError = null, callbackStart = null } = {}) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
					onFresh: () => {
						if ( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( this.values )
						}
					},
					onExpired: () => {
						this.reload( {callbackSuccess, callbackError, callbackStart} )
					}
				})
			);
		});
	}

	static reload = ( {callbackSuccess = null, callbackError = null, callbackStart = null} = {} ) =>{
		this.construct().then( () =>
			{
			return (
				FetchMyBooking.fetchPast({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( bookings ) => {
						// When set add the bookings to the store
						this.process( bookings )

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, bookings, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( bookings );
						}
					}
				})
			);
		}
		);
	}

	static process = ( bookings ) => {
		this.values = bookings;
		
		store.dispatch( setBookingsPast( { ...this.values } ) );
	}
}
